<template>
  <div class="liantong-chart">
    <view-search-form
      ref="searchFormRef"
      :queryInfo.sync="queryInfo"
      :rules="rules"
      :tool-list="['grade','campus']"
      @on-search="renderTable">
<!--      :insert-select-all="[]"-->
      <template #pre-form>
        <el-form-item label="" label-width="0">
          <el-radio-group size="small" v-model="showType" style="margin-top: -5px;">
            <el-radio-button label="grid">表格</el-radio-button>
            <el-radio-button label="chart">图表</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </template>
    </view-search-form>
    <div class="liantong-chart__wrap">
      <el-table v-if="showType==='grid'" :data="tableData" height="100%" stripe>
        <el-table-column prop="dormitoryName" label="宿舍" min-width="300" />
        <el-table-column prop="signInNum" label="报到人数" width="150" align="center" />
        <el-table-column prop="openCardNum" label="开卡人数" width="150" align="center" />
        <el-table-column prop="openCardRate" label="开卡率" width="150" align="center">
          <template #default="{row}">
            {{ row.openCardRate || '0%' }}
          </template>
        </el-table-column>
      </el-table>
      <ChartLiantong v-if="showType==='chart'&&tableData.length" :chart-data="tableData" />
      <el-empty v-else-if="showType==='chart'&&!tableData.length" />
    </div>
  </div>
</template>

<script>
import ChartLiantong from '@/views/pages/recruitManage/liantong-chart/component/ChartLiantong.vue'
import { liantongSummaryByDormApi } from '@/api/student'

export default {
  name: 'LiantongChart',
  components: { ChartLiantong },
  data() {
    return {
      showType: 'grid',
      tableData: [],
      queryInfo: {
        campusId: null,
        grade: new Date().getFullYear()
      },
      rules: {
        campusId: { required: true, message: '请选择校区', trigger: 'blur' },
        grade: { required: true, message: '请选择年级', trigger: 'blur' }
      }
    }
  },
  methods: {
    renderTable() {
      this.$refs.searchFormRef.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const res = await liantongSummaryByDormApi(this.queryInfo)
          this.tableData = res.data
          if (this.showType === 'chart') {
            this.showType = ''
            this.$nextTick(() => {
              this.showType = 'chart'
            })
          }
          try {
          } catch (e) {
            console.error(e)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.liantong-chart {
  height: calc(100vh - 96px);
  background: #fff;

  .view-search-form.el-form {
    padding-left: 10px;
    padding-top: 10px;
  }

  .liantong-chart__wrap {
    height: calc(100% - 72px);
  }
}
</style>
